(function () {
  if (window.__t4sPromoSessionBound) return;
  window.__t4sPromoSessionBound = true;

  var CACHE_PREFIX = 't4s_promo_map_v3_';
  var probePromise = null;
  var probing = false;

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents);
    if (isNaN(cents)) return '';

    var formatString =
      (window.T4SPromoBoot && window.T4SPromoBoot.moneyFormat) ||
      (window.T4Sconfigs && window.T4Sconfigs.moneyFormat) ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount}}';

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    if (!match) return String(cents / 100);

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var num = (number / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = withDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function getCookie(name) {
    var m = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : '';
  }

  function uniqCodes(list) {
    var out = [];
    (list || []).forEach(function (code) {
      if (!code) return;
      code = String(code).toUpperCase().trim();
      if (code && out.indexOf(code) === -1) out.push(code);
    });
    return out;
  }

  function codeFromPath() {
    var m = (location.pathname || '').match(/\/discount\/([^\/\?\#]+)/i);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function readCache(code) {
    try {
      return JSON.parse(sessionStorage.getItem(CACHE_PREFIX + code) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeCache(code, map) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + code, JSON.stringify(map || {}));
    } catch (e) {}
  }

  var silentWinReady = null;
  var upcartOpenOrig = null;
  var upcartRefreshOrig = null;

  function getSilentWin() {
    if (silentWinReady) return silentWinReady;
    silentWinReady = new Promise(function (resolve) {
      var iframe = document.createElement('iframe');
      iframe.name = 't4s-promo-silent';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.tabIndex = -1;
      iframe.style.cssText =
        'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none;left:-9999px';
      iframe.addEventListener('load', function () {
        resolve(iframe.contentWindow);
      });
      iframe.src = 'about:blank';
      document.documentElement.appendChild(iframe);
    });
    return silentWinReady;
  }

  function silentFetch(url, options) {
    return getSilentWin().then(function (win) {
      return win.fetch(url, options || { credentials: 'same-origin' }).then(function (r) {
        return r.json().catch(function () {
          return {};
        });
      });
    });
  }

  function fetchCart() {
    return silentFetch('/cart.js', { credentials: 'same-origin' });
  }

  function postJson(url, body) {
    return silentFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function closeCartDrawers() {
    try {
      if (typeof window.upcartCloseCart === 'function') window.upcartCloseCart();
      if (typeof window.upcartHideCart === 'function') window.upcartHideCart();
    } catch (e) {}
    document.querySelectorAll('[aria-label="Close"], [data-close-cart], .upcart-close, button').forEach(function (btn) {
      var label = ((btn.getAttribute('aria-label') || '') + ' ' + (btn.textContent || '')).toLowerCase();
      if (label.indexOf('close') !== -1 && btn.closest('[class*="upcart" i], [id*="upcart" i]')) {
        try {
          btn.click();
        } catch (e) {}
      }
    });
  }

  function startProbeUi() {
    probing = true;
    document.documentElement.classList.add('t4s-promo-probing');
    if (upcartOpenOrig === null && typeof window.upcartOpenCart === 'function') {
      upcartOpenOrig = window.upcartOpenCart;
      window.upcartOpenCart = function () {};
    }
    if (upcartRefreshOrig === null && typeof window.upcartRefreshCart === 'function') {
      upcartRefreshOrig = window.upcartRefreshCart;
      window.upcartRefreshCart = function () {};
    }
    closeCartDrawers();
  }

  function endProbeUi() {
    if (upcartOpenOrig) {
      window.upcartOpenCart = upcartOpenOrig;
      upcartOpenOrig = null;
    }
    if (upcartRefreshOrig) {
      window.upcartRefreshCart = upcartRefreshOrig;
      upcartRefreshOrig = null;
    }
    closeCartDrawers();
    document.documentElement.classList.remove('t4s-promo-probing');
    probing = false;
  }

  function removeProbeItems(cart) {
    var updates = {};
    ((cart && cart.items) || []).forEach(function (item) {
      if (isProbeItem(item)) updates[item.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(cart || {});
    return postJson('/cart/update.js', { updates: updates });
  }

  function getActiveCodes() {
    var boot = (window.T4SPromoBoot && window.T4SPromoBoot.discountCodes) || [];
    var cookieCode = getCookie('discount_code');
    var pathCode = codeFromPath();
    var stored = '';
    try {
      stored = sessionStorage.getItem('t4s_promo_active_code') || '';
    } catch (e) {}

    return fetchCart()
      .then(function (cart) {
        var fromCart = [];
        if (cart && Array.isArray(cart.discount_codes)) {
          cart.discount_codes.forEach(function (d) {
            if (d && d.code && d.applicable !== false) fromCart.push(d.code);
          });
        }
        var codes = uniqCodes(boot.concat(fromCart, [cookieCode, pathCode, stored]));
        if (codes.length) {
          try {
            sessionStorage.setItem('t4s_promo_active_code', codes[0]);
          } catch (e) {}
        }
        return codes;
      })
      .catch(function () {
        return uniqCodes(boot.concat([cookieCode, pathCode, stored]));
      });
  }

  function itemUnitPrices(item) {
    var qty = Number(item.quantity) || 1;
    var finalLine =
      item.final_line_price != null
        ? Number(item.final_line_price)
        : item.line_price != null
          ? Number(item.line_price)
          : NaN;
    var originalLine =
      item.original_line_price != null
        ? Number(item.original_line_price)
        : NaN;
    var finalPrice = !isNaN(finalLine)
      ? Math.round(finalLine / qty)
      : item.discounted_price != null
        ? Number(item.discounted_price)
        : Number(item.price);
    var originalPrice = !isNaN(originalLine)
      ? Math.round(originalLine / qty)
      : item.original_price != null
        ? Number(item.original_price)
        : finalPrice;
    var compare = Number(item.compare_at_price) || originalPrice;
    return {
      final: finalPrice,
      original: Math.max(originalPrice, compare, finalPrice)
    };
  }

  function itemHasDiscount(item) {
    if (!item) return false;
    var prices = itemUnitPrices(item);
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
      return prices.final < prices.original;
    }
    if (item.discounts && item.discounts.length) {
      return prices.final < prices.original;
    }
    return prices.original && prices.final && prices.final < prices.original;
  }

  function isProbeItem(item) {
    var props = item && item.properties;
    if (!props) return false;
    return !!(props._t4s_probe || props['_t4s_probe']);
  }

  function probeEligibility(code, markers) {
    if (window.Shopify && window.Shopify.designMode) {
      return Promise.resolve(readCache(code));
    }

    var map = readCache(code);
    var needed = [];
    var seen = {};

    markers.forEach(function (marker) {
      var pid = marker.getAttribute('data-product-id');
      var vid = marker.getAttribute('data-variant-id');
      var available = marker.getAttribute('data-available') !== 'false';
      if (!pid || !vid || !available) return;
      if (Object.prototype.hasOwnProperty.call(map, pid)) return;
      if (seen[vid]) return;
      seen[vid] = true;
      needed.push({ pid: pid, vid: Number(vid) });
    });

    if (!needed.length) {
      return fetchCart()
        .then(removeProbeItems)
        .then(function () {
          return map;
        })
        .catch(function () {
          return map;
        });
    }

    if (probePromise) {
      return probePromise.then(function () {
        return probeEligibility(code, markers);
      });
    }

    var chunks = [];
    for (var i = 0; i < needed.length; i += 1) {
      chunks.push(needed.slice(i, i + 1));
    }

    startProbeUi();
    probePromise = fetchCart()
      .then(removeProbeItems)
      .then(function () {
        return postJson('/cart/update.js', { discount: code });
      })
      .then(function () {
        return chunks.reduce(function (chain, chunk) {
          return chain.then(function () {
            var items = chunk.map(function (row) {
              return {
                id: row.vid,
                quantity: 1,
                properties: { _t4s_probe: code }
              };
            });
            return postJson('/cart/add.js', { items: items }).then(function () {
              return fetchCart().then(function (cart) {
                (cart.items || []).forEach(function (item) {
                  if (!isProbeItem(item)) return;
                  var pid = String(item.product_id);
                  var prices = itemUnitPrices(item);
                  map[pid] = itemHasDiscount(item)
                    ? { ok: true, final: prices.final, original: prices.original }
                    : { ok: false };
                });
                chunk.forEach(function (row) {
                  if (!Object.prototype.hasOwnProperty.call(map, row.pid)) map[row.pid] = { ok: false };
                });
                writeCache(code, map);
                return removeProbeItems(cart);
              });
            });
          });
        }, Promise.resolve());
      })
      .then(function () {
        probePromise = null;
        endProbeUi();
        return map;
      })
      .catch(function () {
        probePromise = null;
        return fetchCart()
          .then(removeProbeItems)
          .catch(function () {
            return {};
          })
          .then(function () {
            endProbeUi();
            return map;
          });
      });

    return probePromise;
  }

  function findPriceEl(marker) {
    var root =
      marker.closest('.t4s-product-info__inner') ||
      marker.closest('.t4s-product-info') ||
      marker.closest('.t4s-product__info') ||
      marker.closest('.t4s-product__price-review') ||
      marker.closest('.t4s-product') ||
      marker.parentElement;

    if (!root) return null;
    return (
      root.querySelector('.t4s-product-price') ||
      root.querySelector('[data-product-price]') ||
      root.querySelector('[data-pr-price]')
    );
  }

  function findPromoRow(priceEl) {
    if (!priceEl) return null;
    var uid = priceEl.dataset.t4sPromoUid;
    if (uid) {
      var byUid = document.querySelector('.t4s-promo-row[data-for-price="' + uid + '"]');
      if (byUid) return byUid;
    }
    var next = priceEl.nextElementSibling;
    if (next && next.classList.contains('t4s-promo-row')) return next;
    var stock = priceEl.closest('.t4s-price-stock');
    if (stock) {
      var inside = stock.querySelector('.t4s-promo-row');
      if (inside) return inside;
    }
    return null;
  }

  function promoRowPlacedCorrectly(priceEl, row) {
    if (!priceEl || !row) return false;
    var stock = priceEl.closest('.t4s-price-stock');
    // On product page: promo sits inside the price row, right after the theme price
    if (stock) {
      return row.parentElement === stock && priceEl.nextElementSibling === row;
    }
    return row.previousElementSibling === priceEl;
  }

  function removePromoRows(priceEl) {
    if (!priceEl) return;
    var uid = priceEl.dataset.t4sPromoUid;
    if (uid) {
      document.querySelectorAll('.t4s-promo-row[data-for-price="' + uid + '"]').forEach(function (el) {
        el.remove();
      });
    }
    var stock = priceEl.closest('.t4s-price-stock');
    if (stock) {
      Array.prototype.slice.call(stock.querySelectorAll('.t4s-promo-row')).forEach(function (el) {
        el.remove();
      });
      if (stock.nextElementSibling && stock.nextElementSibling.classList.contains('t4s-promo-row')) {
        stock.nextElementSibling.remove();
      }
    }
    if (priceEl.nextElementSibling && priceEl.nextElementSibling.classList.contains('t4s-promo-row')) {
      priceEl.nextElementSibling.remove();
    }
  }

  function promoRowHtml(promoCents, code, uid) {
    return (
      '<div class="t4s-promo-row" data-for-price="' +
      (uid || '') +
      '" aria-label="Price with promo code">' +
      '<ins class="t4s-promo-final">' +
      formatMoney(promoCents) +
      '</ins> ' +
      '<span class="t4s-promo-code-note">' +
      '<span class="t4s-promo-code-note__label">With code</span> ' +
      '<span class="t4s-promo-code-note__value">' +
      code +
      '</span></span></div>'
    );
  }

  function clearPromo(priceEl) {
    if (!priceEl) return;
    if (priceEl.dataset.t4sPromoOriginalHtml) {
      priceEl.innerHTML = priceEl.dataset.t4sPromoOriginalHtml;
      delete priceEl.dataset.t4sPromoOriginalHtml;
    }
    priceEl.classList.remove('is-promo-active');
    delete priceEl.dataset.t4sPromoApplied;
    removePromoRows(priceEl);
  }

  function applyPromo(marker, code, map) {
    if (marker.closest('.t4s-grouped-product-list')) return;
    var priceEl = findPriceEl(marker);
    var pid = marker.getAttribute('data-product-id');
    var base = parseInt(marker.getAttribute('data-base-price'), 10);
    if (!priceEl || !pid) return;

    // Restore theme price if a previous version replaced it
    if (priceEl.dataset.t4sPromoOriginalHtml && priceEl.querySelector('.t4s-promo-final, .t4s-promo-base, .t4s-promo-with')) {
      priceEl.innerHTML = priceEl.dataset.t4sPromoOriginalHtml;
    }
    if (!priceEl.dataset.t4sPromoOriginalHtml) {
      priceEl.dataset.t4sPromoOriginalHtml = priceEl.innerHTML;
    }
    if (!priceEl.dataset.t4sPromoUid) {
      priceEl.dataset.t4sPromoUid = 'p' + pid + '-' + Math.random().toString(36).slice(2, 7);
    }

    var entry = map[pid];
    var active = !!(code && entry && entry.ok && entry.final < (entry.original || base));
    if (!active) {
      clearPromo(priceEl);
      return;
    }

    var promoCents = Number(entry.final);
    var stateKey = code + ':' + promoCents;
    var existing = findPromoRow(priceEl);
    if (priceEl.dataset.t4sPromoApplied === stateKey && promoRowPlacedCorrectly(priceEl, existing)) {
      return;
    }

    priceEl.classList.add('is-promo-active');
    priceEl.dataset.t4sPromoApplied = stateKey;
    removePromoRows(priceEl);
    // Keep promo on the same price row (above border), right after theme price
    priceEl.insertAdjacentHTML('afterend', promoRowHtml(promoCents, code, priceEl.dataset.t4sPromoUid));
  }

  function groupedUnitPrice(sl, entry) {
    var orig = parseInt(sl.dataset.t4sOrigPrice || sl.getAttribute('data-price'), 10);
    if (isNaN(orig)) return 0;
    if (entry && entry.ok) return Number(entry.final);
    return orig;
  }

  function updateGroupedFieldPrice(sl, entry) {
    if (!sl.dataset.t4sOrigPrice) sl.dataset.t4sOrigPrice = sl.getAttribute('data-price') || '0';
    sl.querySelectorAll('option[data-price]').forEach(function (opt) {
      if (!opt.dataset.t4sOrigPrice) opt.dataset.t4sOrigPrice = opt.getAttribute('data-price') || '0';
      var orig = parseInt(opt.dataset.t4sOrigPrice, 10);
      if (isNaN(orig)) return;
      var price = orig;
      if (entry && entry.ok && entry.original) {
        price = Math.round(orig * (Number(entry.final) / Number(entry.original)));
      }
      opt.setAttribute('data-price', price);
    });
  }

  function applyGroupedPromos(code, map) {
    document.querySelectorAll('[data-groups-pr-form]').forEach(function (form) {
      var total = 0;
      var compare = 0;
      form.querySelectorAll('[data-groups-pr-item]').forEach(function (row) {
        var sl = row.querySelector('[data-groups-pr-sl]');
        var qtyEl = row.querySelector('[data-groups-qty-value]');
        var priceEl = row.querySelector('[data-groups-item-price]');
        if (!sl) return;
        var pid = row.getAttribute('data-product-id');
        var entry = pid && map ? map[pid] : null;
        var selected = sl.tagName === 'SELECT' ? sl.options[sl.selectedIndex] : sl;
        if (selected && !selected.dataset.t4sOrigPrice && selected.getAttribute('data-price')) {
          selected.dataset.t4sOrigPrice = selected.getAttribute('data-price');
        }
        if (!sl.dataset.t4sOrigPrice) {
          sl.dataset.t4sOrigPrice = (selected && selected.dataset.t4sOrigPrice) || sl.getAttribute('data-price') || '0';
        }
        updateGroupedFieldPrice(sl, entry);
        var unit = groupedUnitPrice(selected || sl, entry);
        sl.setAttribute('data-price', unit);
        var orig = Number(entry && entry.original) || parseInt((selected && selected.dataset.t4sOrigPrice) || sl.dataset.t4sOrigPrice || unit, 10);
        var qty = parseInt(qtyEl && qtyEl.value, 10) || 0;
        if (priceEl) {
          if (!priceEl.dataset.t4sGroupedOrigHtml) priceEl.dataset.t4sGroupedOrigHtml = priceEl.innerHTML;
          if (entry && entry.ok && unit < orig) {
            priceEl.innerHTML = '<del>' + formatMoney(orig) + '</del> <ins>' + formatMoney(unit) + '</ins>';
          } else {
            priceEl.innerHTML = priceEl.dataset.t4sGroupedOrigHtml;
          }
        }
        if (qty > 0) {
          total += unit * qty;
          compare += orig * qty;
        }
      });
      var totalEl = form.querySelector('[data-groups-total-price]');
      if (!totalEl) return;
      if (!totalEl.dataset.t4sGroupedOrigHtml) totalEl.dataset.t4sGroupedOrigHtml = totalEl.innerHTML;
      if (total <= 0) {
        totalEl.innerHTML = formatMoney(0);
      } else if (code && total < compare) {
        totalEl.innerHTML = '<del>' + formatMoney(compare) + '</del> <ins>' + formatMoney(total) + '</ins>';
      } else {
        totalEl.innerHTML = formatMoney(total);
      }
    });
  }

  var lastPromoCode = '';
  var lastPromoMap = {};

  function showDiscountToast(codes) {
    if (!codes || !codes.length) return;
    var code = codes[0];
    var key = 't4s_promo_toast_' + code;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {}

    var existing = document.querySelector('.t4s-promo-toast');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.className = 't4s-promo-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<strong>Discount applied:</strong> <span>' +
      code +
      '</span> — sale prices are shown on products this code applies to.' +
      '<button type="button" class="t4s-promo-toast__close" aria-label="Close">&times;</button>';
    document.body.appendChild(el);

    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });

    var close = function () {
      el.classList.remove('is-visible');
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 300);
    };
    el.querySelector('.t4s-promo-toast__close').addEventListener('click', close);
    setTimeout(close, 8000);
  }

  function refresh() {
    var markers = document.querySelectorAll('.t4s-promo-price-data[data-product-id]');
    if (!markers.length) return;

    getActiveCodes().then(function (codes) {
      if (!codes.length) {
        markers.forEach(function (marker) {
          var priceEl = findPriceEl(marker);
          if (priceEl) clearPromo(priceEl);
        });
        lastPromoCode = '';
        lastPromoMap = {};
        applyGroupedPromos('', {});
        return;
      }

      showDiscountToast(codes);
      var code = codes[0];
      probeEligibility(code, markers).then(function (map) {
        lastPromoCode = code;
        lastPromoMap = map || {};
        markers.forEach(function (marker) {
          applyPromo(marker, code, map);
        });
        applyGroupedPromos(code, map);
      });
    });
  }

  function boot() {
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('[data-groups-pr-form]')) return;
    if (!e.target.matches('[data-groups-qty-value], [data-groups-pr-sl], [data-quantity-value]')) return;
    applyGroupedPromos(lastPromoCode, lastPromoMap);
  });
  document.addEventListener('input', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('[data-groups-pr-form]')) return;
    if (!e.target.matches('[data-groups-qty-value], [data-quantity-value]')) return;
    applyGroupedPromos(lastPromoCode, lastPromoMap);
  });
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('[data-groups-pr-form] [data-quantity-selector]')) return;
    setTimeout(function () {
      applyGroupedPromos(lastPromoCode, lastPromoMap);
    }, 50);
  });
  document.addEventListener('cart:updated', function () {
    if (probing) return;
    setTimeout(refresh, 300);
  });

  var obsTimer = null;
  var obs = new MutationObserver(function (mutations) {
    var hasNew = mutations.some(function (m) {
      return Array.prototype.some.call(m.addedNodes || [], function (node) {
        if (node.nodeType !== 1) return false;
        return (
          (node.matches && node.matches('.t4s-promo-price-data[data-product-id]')) ||
          (node.querySelector && node.querySelector('.t4s-promo-price-data[data-product-id]'))
        );
      });
    });
    if (!hasNew) return;
    clearTimeout(obsTimer);
    obsTimer = setTimeout(refresh, 250);
  });

  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true });
  }
})();
